<template>
  <el-form
    :model="ruleForm2"
    :rules="rules2"
    ref="ruleForm2"
    label-position="left"
    label-width="0px"
    class="demo-ruleForm login-container"
    autocomplete="on"
  >
    <h3 class="title">系统登录</h3>
    <!-- 账号输入框（支持自动填充） -->
    <el-form-item prop="account">
      <el-input
        type="text"
        v-model="ruleForm2.account"
        autocomplete="username"
        name="username"
        placeholder="账号"
      ></el-input>
    </el-form-item>
    <!-- 密码输入框（支持自动填充，保留星号显示） -->
    <el-form-item prop="checkPass">
      <el-input
        type="password"
        v-model="ruleForm2.checkPass"
        autocomplete="current-password"
        name="password"
        class="no-autofill-pwd"
        placeholder="密码"
      ></el-input>
    </el-form-item>
    <el-checkbox v-model="checked" class="remember"> 记住密码 </el-checkbox>
    <el-form-item style="width: 100%">
      <el-button
        type="primary"
        style="width: 100%"
        @click.native.prevent="handleSubmit2"
        :loading="logining"
        >登录</el-button
      >
    </el-form-item>
  </el-form>
</template>

<script>
import { loginApi } from "../utils/api";
import supper from "./nav1/supper.vue";
// 导入VueRouter（修复路由重置时的依赖）
import VueRouter from "vue-router";

export default {
  data() {
    return {
      logining: false,
      ruleForm2: {
        account: "",
        checkPass: "",
      },
      rules2: {
        account: [{ required: true, message: "请输入账号", trigger: "blur" }],
        checkPass: [{ required: true, message: "请输入密码", trigger: "blur" }],
      },
      checked: true,
    };
  },
  mounted() {
    // 加载记住的账号密码
    let userInfo = JSON.parse(localStorage.getItem("userInfo"));
    if (userInfo) {
      this.ruleForm2 = userInfo;
    }
  },
  methods: {
    handleReset2() {
      this.$refs.ruleForm2.resetFields();
    },

    handleSubmit2(ev) {
      ev.preventDefault(); // 阻止默认表单提交
      const _this = this;

      this.$refs.ruleForm2.validate((valid) => {
        if (valid) {
          this.logining = true;
          const loginParams = {
            username: this.ruleForm2.account,
            password: this.ruleForm2.checkPass,
          };

          loginApi(loginParams)
            .then((data) => {
              this.logining = false;
              if (data.code !== 200) {
                this.$message.error(data.msg);
                return;
              }

              // 存储登录状态和权限
              localStorage.setItem("token", data.data.token);
              localStorage.setItem("username", data.data.username);
              localStorage.setItem("supper", data.data.supper || "0");
              // 处理记住密码
              if (this.checked) {
                localStorage.setItem(
                  "userInfo",
                  JSON.stringify(this.ruleForm2)
                );
              } else {
                localStorage.removeItem("userInfo");
              }

              // 3. 关键修复：路由操作完成后，延迟跳转（确保路由匹配器已同步）
              this.handleSupperRoute().then(() => {
                // 路由重置/添加完成后，再执行跳转
                _this.$router.push({ path: "/table" });
              });
            })
            .catch(() => {
              this.logining = false;
              this.$message.error("网络异常，登录请求失败");
            });
        } else {
          this.$message.error("请完善账号和密码信息");
        }
      });
    },

    // 获取supper权限（封装复用）
    getSupperPermission() {
      try {
        return parseInt(localStorage.getItem("supper") || "0", 10);
      } catch (e) {
        console.error("获取supper权限失败:", e);
        return 0;
      }
    },

    // 4. 关键修复：将路由处理改为Promise，明确告知操作完成时机
    handleSupperRoute() {
      return new Promise((resolve) => {
        const supperPermission = this.getSupperPermission();
        const orderRouteIndex = this.$router.options.routes.findIndex(
          (route) => route.name === "订单"
        );

        if (orderRouteIndex === -1) {
          console.error("未找到'订单'路由，无法处理supper权限");
          resolve(); // 即使失败，也需执行resolve，避免阻塞跳转
          return;
        }

        const orderRoute = { ...this.$router.options.routes[orderRouteIndex] };
        let isRouteChanged = false; // 标记路由是否有变化

        // 有权限：添加路由
        if (supperPermission === 1) {
          const hasSupperRoute = orderRoute.children.some(
            (child) => child.path === "/supper"
          );
          if (!hasSupperRoute) {
            orderRoute.children.push({
              path: "/supper",
              component: supper,
              name: "gateATM补单",
            });
            this.$router.options.routes[orderRouteIndex] = orderRoute;
            this.$router.addRoutes([orderRoute]);
            isRouteChanged = true;
          }
        }
        // 无权限：移除路由
        else {
          const originalChildLength = orderRoute.children.length;
          orderRoute.children = orderRoute.children.filter(
            (child) => child.path !== "/supper"
          );
          if (orderRoute.children.length !== originalChildLength) {
            this.$router.options.routes[orderRouteIndex] = orderRoute;
            this.$router.matcher = new VueRouter().matcher; // 重置匹配器
            this.$router.addRoutes(this.$router.options.routes); // 重新添加所有路由
            isRouteChanged = true;
          }
        }

        // 5. 关键修复：若路由有变化，延迟resolve（给路由匹配器同步时间）
        if (isRouteChanged) {
          setTimeout(() => resolve(), 100); // 100ms足够路由同步，避免报错
        } else {
          resolve(); // 路由无变化，直接resolve
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.login-container {
  border-radius: 5px;
  background-clip: padding-box;
  margin: 180px auto;
  width: 350px;
  padding: 35px 35px 15px 35px;
  background: #fff;
  border: 1px solid #eaeaea;
  box-shadow: 0 0 25px #cac6c6;

  .title {
    margin: 0 auto 40px;
    text-align: center;
    color: #505458;
  }

  .remember {
    margin: 0 0 35px;
  }

  // 保留密码星号显示，兼容自动填充
  .no-autofill-pwd {
    /deep/ .el-input__inner {
      -webkit-text-security: disc !important;
    }
  }
}
</style>